import { formatCurrency } from '@packages/format';
export function describeUnpaidInvoicesTotal(totalDueMinorUnits, currency, scope) {
    if (scope?.clientProjectId) {
        return { kind: 'matter', displayMinorUnits: totalDueMinorUnits, text: formatCurrency(totalDueMinorUnits, currency) };
    }
    const inCredit = totalDueMinorUnits < 0;
    const displayMinorUnits = inCredit ? -totalDueMinorUnits : totalDueMinorUnits;
    return {
        kind: 'client',
        label: inCredit ? 'Credit balance' : 'Total due',
        displayMinorUnits,
        text: formatCurrency(displayMinorUnits, currency),
    };
}
/**
 * The line between the invoices subtotal and the total: the business balance
 * no invoice row carries. Null when it is zero, so the line is omitted.
 *
 * A debit reads "balance not linked to an invoice" rather than naming a
 * source, because it can carry an invoice the ledger cannot attribute to a row
 * (an imported or mixed-era invoice) as well as an untagged debit.
 */
export function describeUnlinkedBalance(unlinkedBalanceMinorUnits, currency) {
    if (unlinkedBalanceMinorUnits === 0)
        return null;
    const credit = unlinkedBalanceMinorUnits < 0;
    const displayMinorUnits = credit ? -unlinkedBalanceMinorUnits : unlinkedBalanceMinorUnits;
    return {
        label: credit ? 'Less: unallocated credits' : 'Add: balance not linked to an invoice',
        displayMinorUnits,
        text: formatCurrency(displayMinorUnits, currency),
    };
}
/**
 * The totals block, top to bottom: the invoices subtotal, the unlinked balance
 * line when non-zero, then the final figure. A surface that shows the
 * subtotal only alongside an unlinked line filters `lines` itself.
 */
export function unpaidInvoicesTotalsLines(statement) {
    const unlinked = describeUnlinkedBalance(statement.unlinkedBalanceMinorUnits, statement.currency);
    return {
        lines: [
            {
                key: 'invoices',
                label: 'Unpaid invoices',
                displayMinorUnits: statement.unpaidInvoicesMinorUnits,
                text: formatCurrency(statement.unpaidInvoicesMinorUnits, statement.currency),
            },
            ...(unlinked ? [{ key: 'unlinked', ...unlinked }] : []),
        ],
        total: describeUnpaidInvoicesTotal(statement.totalDueMinorUnits, statement.currency, statement),
    };
}
// =============================================================================
// Row amounts
// =============================================================================
/** The part of an invoice already paid or credited, as "of R1,200.00" under its outstanding amount; null when nothing has been. */
export function describeUnpaidInvoiceRowTotal(row, formatAmount) {
    return row.paidOrCreditedMinorUnits > 0 ? `of ${formatAmount(row.totalMinorUnits)}` : null;
}
